var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissingInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 131,
    viewBox: "0 0 137 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5173 11.4503C94.1131 13.162 98.3562 16.0926 101.796 19.5126C106.728 24.35 110.498 30.258 113.901 36.2539C124.954 55.7254 129.086 81.8847 110.94 97.1922C98.7283 107.446 81.7 109.685 66.1804 108.996C43.4063 107.958 4.49022 90.8559 17.5007 60.0621C24.4959 43.529 45.6029 39.4569 57.0171 27.2007C62.3613 21.4072 66.2449 13.3294 74.0548 10.7368C79.1387 9.03769 84.564 9.53762 89.5173 11.4503Z",
    fill: "#2C74FF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3475 37.3717C94.3474 36.5796 94.0362 35.8201 93.4824 35.2601L81.7188 23.313H41.1988C39.5681 23.313 38.2461 24.6502 38.2461 26.2998V89.0219C38.2461 90.6714 39.5681 92.0086 41.1988 92.0086H59.8236H94.3475V57.6608V37.3717Z",
    fill: "white",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23.5V36H94",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.8922,
    cy: 58.2332,
    r: 1,
    fill: "#A9B0BC",
    stroke: "#2C74FF",
    strokeWidth: 1.43478
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0358,
    cy: 58.2332,
    r: 1,
    fill: "#A9B0BC",
    stroke: "#2C74FF",
    strokeWidth: 1.43478
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8283 67.3383C69.7631 67.9533 68.5871 68.3524 67.3677 68.513C66.1482 68.6735 64.909 68.5923 63.7209 68.274",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4593 54.4522C83.63 54.4522 82.8152 54.2339 82.097 53.8192C81.3788 53.4045 80.7823 52.8081 80.3677 52.0899",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6386 48.6551C51.2239 49.3734 50.6275 49.9698 49.9092 50.3845C49.191 50.7991 48.3762 51.0175 47.5469 51.0175",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5211 18.1608L27.9414 14.1536",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6351 14.057L37.6055 8.42896",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1346 23.8017L24.5068 23.8649",
    stroke: "#2C74FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInformation);
export default __webpack_public_path__ + "static/media/MissingInformation.3b365ddf.svg";
export { ForwardRef as ReactComponent };